import React, { useEffect, useRef, useState } from 'react';
import Chart from 'chart.js/auto';

const CountryChart = ({ attendees }) => {
  const chartRef = useRef();
  const chartInstance = useRef(null);
  const [Iraq, SetIraq] = useState(0) ; 

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }
    SetIraq(0);
    const countries = {};
    attendees.forEach((attendee) => {
      if (attendee.country !== 'Iraq') {
        countries[attendee.country] = (countries[attendee.country] || 0) + 1;
      }else SetIraq ((prev)=> prev+1)  ; 
    });

   const sortedCountries = Object.entries(countries).sort((a, b) => b[1] - a[1]);
    const labels = sortedCountries.map((entry) => entry[0]);
    const data = sortedCountries.map((entry) => entry[1]);

    const barColors = [ "blue" ,"yallow", "green", "red", "orange", "brown", "black" , "crimson"];
    const backgroundColors = barColors.slice(0, data.length);

    const ctx = chartRef.current.getContext('2d');

    chartInstance.current = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Number of Attendees per Country',
            data: data,
            backgroundColor: backgroundColors,
          },
        ],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    });

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [attendees]);

  return (
    <div className=''>
      <h2> beside the Iraqi   <span className='text-red-700 	'> {Iraq}  Attendant</span> </h2>
      <canvas ref={chartRef} />
    </div>
  );
};

export default CountryChart;